module.exports = __webpack_public_path__ + "static/media/choice1.d6b9dc3c.png";